import m from "../../es2015/lang/sr_RS";
window.am4lang_sr_RS = m;


//////////////////
// WEBPACK FOOTER
// ./lang/sr_RS.js
// module id = null
// module chunks = 